import { NgModule } from '@angular/core';

import { DaySharedComponent } from './day.component';
import { FnsFormatPipeModule } from '../../../shared/pipe/date/format/fns-format.pipe.module';

@NgModule({
    declarations: [
        DaySharedComponent
    ],
    imports: [
        FnsFormatPipeModule
    ],
    exports: [
        DaySharedComponent
    ]
})

export class DaySharedModule {}
